// Data pro Den Zlínského kraje 2026

export const eventInfo = {
  title: "Den Zlínského kraje",
  subtitle: "Ochutnejte kraj všemi smysly",
  date: "26. 9. 2026",
  location: "Zlín, Baťův mrakodrap a okolí",
  eventId: "den-zk-2026",
  entryFee: "Vstup zdarma",
  description: "Roční setkání obyvatel Zlínského kraje s bohatým programem, regionálními produkty, koncerty a atrakcemi pro celou rodinu."
};

export const heroImage = "https://denzk.cz/wp-content/uploads/2021/10/1181_foto_Ji%C2%B2i_Balat-scaled.jpg";

export const highlights = [
  {
    icon: "Music",
    title: "Koncerty",
    description: "Paulie Garand, O5 a Radeček, Fleret, Street 69 a další"
  },
  {
    icon: "Sparkles",
    title: "Atrakce",
    description: "Pro děti i dospělé - biathlon, šlapací letadla, dopravní hřiště"
  },
  {
    icon: "ShoppingBag",
    title: "Trhy a stánky",
    description: "Regionální potraviny, řemesla, farmářská stezka"
  },
  {
    icon: "Heart",
    title: "Jedu na dřeň",
    description: "Registrace dárců kostní dřeně - zachraňte život"
  }
];

export const programLocations = [
  {
    name: "Budova 21 – Baťův mrakodrap",
    image: "https://denzk.cz/wp-content/uploads/2021/07/2156c2b1-bc27-402b-ad0b-20f788356e49.jpg",
    activities: [
      "Výstavy",
      "Projížďky Baťovým výtahem",
      "Pozorování slunce na terase",
      "Běh na počest Emila Zátopka",
      "Prezentace mysliveckých spolků",
      "Soutěž hasičů v běhu do schodů",
      "Kavárna na 16. etáži"
    ]
  },
  {
    name: "14|15 Baťův Institut a platforma",
    image: "https://denzk.cz/wp-content/uploads/2021/10/1181_foto_Ji%C2%B2i_Balat-scaled.jpg",
    activities: [
      "Hudební stage A",
      "Gastro zóna"
    ]
  },
  {
    name: "Parkoviště 16 (Cream)",
    image: "https://denzk.cz/wp-content/uploads/2021/10/0372_foto_Ji%C2%B2i_Balat-scaled.jpg",
    activities: [
      "Třídění odpadů hravě",
      "Prezentace středních škol Zlínského kraje",
      "Fotokoutek, biatlon, včelaři, rybáři",
      "Dopravní hřiště"
    ]
  },
  {
    name: "Parkoviště Gahurova",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_kontakt-gastro-hub/artifacts/l0scvt3j_gahurova.jpg",
    activities: [
      "Hudební a gastro stage B - koncerty, livecooking, program pro děti",
      "Farmářská stezka a festival řemesel pro děti",
      "Gastro zóna"
    ]
  },
  {
    name: "Parkoviště mezi 22. a 23. budovou a Budova 22",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_kontakt-gastro-hub/artifacts/kze8dzie_letadlo.jpg",
    activities: [
      "Letecké muzeum Kunovice – šlapací letadla",
      "Czech Pedal Car - šlapací autíčka",
      "Ukázkový byt chytrých technologií pro osoby se sníženou soběstačností"
    ]
  },
  {
    name: "Ulice Vavrečkova",
    image: "https://denzk.cz/wp-content/uploads/2025/08/R3B4035-scaled.jpg",
    activities: [
      "Vinařská ulička - ochutnávky vín z regionu",
      "Centrum řemesel - ukázka šití bot",
      "Vojenská technika",
      "Ukázky práce IZS - hasiči, záchranná služba, policie",
      "TIC Zlín",
      "ZRIA - podpora rozvoje kraje",
      "Kampaň 'Jedu na dřeň' - registr dárců kostní dřeně"
    ]
  }
];

export const mainStageProgram = [
  { time: "10:00", artist: "Zahájení", description: "Radim Holiš, hejtman Zlínského kraje" },
  { time: "11:00", artist: "Paulie Garand", description: "Český rapper a producent" },
  { time: "12:30", artist: "O5 a Radeček", description: "Populární česká hudební dvojice" },
  { time: "14:00", artist: "Street 69", description: "Zlínská ska punková kapela" },
  { time: "15:30", artist: "Fleret a Zuzana Šuláková", description: "Moravská hudba s vlastním stylem" },
  { time: "17:00", artist: "Reflexy", description: "Rocková kapela" },
  { time: "18:30", artist: "12:PIET", description: "Alternativní rock" },
  { time: "20:00", artist: "Hluchý Dovrat", description: "Moravská kapela" }
];

export const regionalProducts = [
  { name: "Hostinář", category: "Paštiky" },
  { name: "Farma Rudimov", category: "Farmářské produkty" },
  { name: "Moštárna Hostětín", category: "Mošty a džusy" },
  { name: "VOMA", category: "Masné výrobky" },
  { name: "Kozí farma Vizovice", category: "Kozí sýry" },
  { name: "Cyrilovo pekařství", category: "Frgály" },
  { name: "Pivovar Kroměříž", category: "Pivo" },
  { name: "Pivovar Malenovice", category: "Zlínský švec" },
  { name: "Topolský pivovar", category: "Pivo" },
  { name: "VENISON CZ", category: "Zvěřinové výrobky" },
  { name: "Medovina a med", category: "Med" },
  { name: "Sušírna z pod Radhošťa", category: "Sušené ovoce" }
];

export const wineStalls = [
  "Vinařství Rochůz (Uherské Hradiště)",
  "Šlechtitelská stanice Polešovice",
  "VÍNO ZLOMEK & VÁVRA (Boršice u Blatnice)",
  "Vinařství U Kostela (Polešovice)",
  "Vinařství Jakubík (Zlechov)",
  "Dvůr pod Starýma Horama (Boršice)",
  "Vinařství Vaďura (Polešovice)",
  "AGRO Zlechov + RED winery"
];

export const partners = [
  {
    name: "Zlínský kraj",
    logo: "https://denzk.cz/wp-content/uploads/2022/06/zlinsky_kraj.svg"
  },
  {
    name: "Baťův institut",
    logo: "https://denzk.cz/wp-content/uploads/2021/05/rectangle-223.png"
  },
  {
    name: "CREAM",
    logo: "https://denzk.cz/wp-content/uploads/2024/09/LOGO-CREAM.png"
  }
];

export const contactInfo = {
  email: "promo@vseproakci.cz",
  phone: "+420 770 674 425",
  address: "Zlínský kraj, třída Tomáše Bati 21, 761 90 Zlín",
  facebook: "https://www.facebook.com/zlkraj/",
  instagram: "https://www.instagram.com/explore/tags/denzlinskehokraje/"
};

// Vendor pricing for this event
export const vendorPricing = {
  mainSeller: {
    title: "Food trucky/stánky s jídlem",
    size: "do 6x3 m",
    price: 6000,
    description: "Hlavní prodejci jídla - cena včetně elektřiny"
  },
  otherSeller: {
    title: "Sladké, pochutiny",
    size: "max. 6x3 m",
    price: 3000,
    description: "Ostatní prodejci"
  },
  electricity: {
    "DO 3KW": 0,
    "3KW až 6KW": 0,
    "nad 6KW": 0,
    "Nepotřebuji": 0
  }
};

export const importantInfo = [
  "Akce se koná 26. září 2026 v centru Zlína",
  "Vstup pro návštěvníky zdarma",
  "Prodejci musí mít vlastní stánek a vybavení",
  "Dodržování hygienických a protipožárních předpisů",
  "Prodej pouze regionálních a kvalitních produktů",
  "Stavba stánků od 6:00, akce od 9:00 do 21:00"
];
